import { Trans as TransComponent } from 'react-i18next/TransWithoutContext';

export function Trans(props: React.ComponentProps<typeof TransComponent>) {
  return (
    <TransComponent
      {...props}
      components={{
        strong: <span className="font-semibold" />,
        ...props.components,
      }}
    />
  );
}
